<template>
  <div style="z-index: 1000">
    <AnnouncementListPage v-if="$route.path == '/console/announcement/list'" />
    <MailPage v-if="$route.path == '/console/mail/mailPage'" />
    <MarqueeListPage v-if="$route.path == '/console/marquee/list'" />
    <QQGroupListPage v-if="$route.path == '/console/qq-group'" />
    <ChatManagePage v-if="$route.path == '/console/chat'" />
    <BlackListPage v-if="$route.path == '/console/black-list'" />
    <GreyListPage v-if="$route.path == '/console/grey-list'" />
    <WhiteListTabPanelPage v-if="$route.path == '/console/white-list'" />
    <PictureListPage v-if="$route.path == '/console/picture'" />
    <FunctionSwitchListPage
      v-if="$route.path == '/console/function-switch/list'"
    />
    <VersionTabPanelPage v-if="$route.path == '/console/version/list'" />
    <RedeemCodeManagePage v-if="$route.path == '/console/redeem-code'" />
    <ZoneListPage v-if="$route.path == '/console/zone/list'" />
    <GuildListPage v-if="$route.path == '/console/guild/guildList'" />
    <PlayerManagePage v-if="$route.path == '/console/player/playerlist'" />
    <ActivityManagePage
      v-if="$route.path == '/console/activity/activityList'"
    />
    <AccountListPage v-if="$route.path == '/console/account/accountList'" />
    <AssetChangeListPage
      v-if="$route.path == '/console/asset-change/asset-change-list'"
    />
    <SystemConfigManagePage
      v-if="$route.path == '/console/systemConfigManage'"
    />
    <PayManagePage v-if="$route.path == '/console/payManage'" />
    <ReportFormsManagePage v-if="$route.path == '/console/reportFormsManage'" />
    <Dialogs />
  </div>
</template>

<script>
import AnnouncementListPage from "@/pages/announcement/AnnouncementListPage";
import MailPage from "@/pages/mail/MailPage";
import MarqueeListPage from "@/pages/marquee/MarqueeListPage";
import QQGroupListPage from "@/pages/qq-group/QQGroupListPage";
import ChatManagePage from "@/pages/chat/ChatManagePage";
import BlackListPage from "@/pages/black-list/BlackListPage";
import GreyListPage from "@/pages/grey-list/GreyListPage";
import WhiteListTabPanelPage from "@/pages/white-list/WhiteListTabPanelPage";
import PictureListPage from "@/pages/picture/PictureListPage";
import FunctionSwitchListPage from "@/pages/function-switch/FunctionSwitchListPage";
import VersionTabPanelPage from "@/pages/version/VersionTabPanelPage";
import ZoneListPage from "@/pages/zone/ZoneManagePage";
import GuildListPage from "@/pages/guild/GuildListPage";
import PlayerManagePage from "@/pages/player/PlayerManagePage";
import ActivityManagePage from "@/pages/activity/ActivityManagePage";
import AccountListPage from "@/pages/account/AccountListPage";
import Dialogs from "./Dialogs";
import AssetChangeListPage from "@/pages/asset-change/AssetChangeListPage";
import SystemConfigManagePage from "@/pages/system-config/SystemConfigManagePage";
import RedeemCodeManagePage from "@/pages/redeem-code/RedeemCodeManagePage";
import PayManagePage from "@/pages/pay/PayManagePage";
import ReportFormsManagePage from "@/pages/report-forms/ReportFormsManagePage";

export default {
  data() {
    return {};
  },

  components: {
    Dialogs,
    AnnouncementListPage,
    MailPage,
    MarqueeListPage,
    QQGroupListPage,
    ChatManagePage,
    BlackListPage,
    GreyListPage,
    WhiteListTabPanelPage,
    PictureListPage,
    FunctionSwitchListPage,
    VersionTabPanelPage,
    ZoneListPage,
    GuildListPage,
    PlayerManagePage,
    ActivityManagePage,
    AccountListPage,
    AssetChangeListPage,
    SystemConfigManagePage,
    RedeemCodeManagePage,
    PayManagePage,
    ReportFormsManagePage,
  },

  created() {},

  methods: {},
};
</script>